module.exports = __webpack_public_path__ + "img/status_badge_bullet_to_do.7f05bd05.svg";